import {
  Admin as RaAdmin,
  CustomRoutes,
  Resource,
  type TranslationMessages,
  resolveBrowserLocale,
} from 'react-admin'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { Route } from 'react-router-dom'
import log from 'loglevel'
import React from 'react'
import { ja } from './translations-ja'
import { DataProvider } from '../DataProvider'
import { desktopTheme, otherTheme } from '../Theme'
import FormBase from '../FormBase'
import PageNotFound from '../PageNotFound'
import FormInput from '../FormInput'
import FormConfirm from '../FormConfirm'
import { ThanksPage } from '../ThanksPage'
import { LayoutWithoutTitle } from '../Layout'
import { useMediaQuery } from '@mui/material'

log.setLevel(log.levels.DEBUG)
const projectId = "019e719d-361f-7331-bbf1-d4956cbc484b"
const translations: Record<string, TranslationMessages> = { ja }
const defaultI18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] as TranslationMessages,
  resolveBrowserLocale(),
  [{ locale: 'ja', name: '日本語' }]
  // { allowMissing: true }
)
const dataProvider = DataProvider()
export const Admin: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 900px)')
  return (
    <RaAdmin
      dataProvider={dataProvider}
      i18nProvider={defaultI18nProvider}
      theme={isDesktop ? desktopTheme : otherTheme}
      layout={LayoutWithoutTitle}
    >
      <Resource name={projectId} />
      <CustomRoutes>
        <Route path={`${projectId}/`} element={<FormBase projectId={projectId} />}>
          <Route path={`${projectId}/input`} element={<FormInput />} />
          <Route path={`${projectId}/confirm`} element={<FormConfirm />} />
          <Route path={`${projectId}/complete`} element={<ThanksPage />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </CustomRoutes>
    </RaAdmin>
  )
}
